<div class="dashboard-container">
  <div class="image-container">
    <div class="hero-text-1">
      {{ HeroText1 }}
    </div>
    <div class="hero-text-2">
      {{ HeroText2 }}
    </div>
    <div class="hero-text-3">
      {{ HeroText3 }}
    </div>
  </div>
  <div class="content-container" *ngIf="overviewData; else isLoading">
    <app-page-header
      [title]="Welcome"
      [groupName]="overviewData.policyHolder"
      [groupNumber]="overviewData.policyNumber"
    ></app-page-header>
    <div class="layout weighted-left">
      <div class="column-container">
        <div class="layout">
          <dxo-card-responsive [bodyHeader]="quickLinksHeader" class="quick-links-card">
            <card-body>
              <div class="quick-link">
                <h3>{{ employerQuickLink.title }}</h3>
                <div class="link-container">
                  <a target="_blank" [href]="employerQuickLink.link">{{ employerQuickLink.text }}</a>
                  <a target="_blank" [href]="employerQuickLink.link" class="icon-link">
                    <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
                  </a>
                </div>
              </div>

              <div class="quick-link">
                <h3>{{ employeeQuickLink.title }}</h3>
                <div class="link-container">
                  <a target="_blank" [href]="employeeQuickLink.link">{{ employeeQuickLink.text }}</a>
                  <a target="_blank" [href]="employeeQuickLink.link" class="icon-link">
                    <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
                  </a>
                </div>
              </div>

              <div class="quick-link-w-image">
                <img src="/assets/images/podcast-image.png" alt="Working Forward Podcast" />
                <div>
                  <h3>{{ podcastQuickLink.title }}</h3>
                  <div class="link-container">
                    <a target="_blank" [href]="podcastQuickLink.link">{{ podcastQuickLink.text }}</a>
                    <a target="_blank" [href]="podcastQuickLink.link" class="icon-link">
                      <dxo-icon fontSize="16" color="blue">{{ quickLinkIcon }}</dxo-icon>
                    </a>
                  </div>
                </div>
              </div>
            </card-body>
          </dxo-card-responsive>

          <dxo-card-responsive
            [bodyHeader]="settingsBodyHeader"
            class="settings-card"
            *ngIf="showToggle"
            data-e2e="settings-card-header"
          >
            <card-body>
              <div class="settings-container">
                <dxo-toggle
                  (valueChange)="toggleInvoiceNotifications($any($event))"
                  [value]="invoiceNotificationsEnabled"
                  [text]="InvoiceNotificationsText"
                  data-e2e="invoice-notifications-toggle"
                ></dxo-toggle>
              </div>
            </card-body>
          </dxo-card-responsive>
        </div>
      </div>
      <div class="column-container contacts">
        <div class="layout">
          <div class="min-width">
            <dxo-card-responsive *ngIf="hasContacts" [bodyHeader]="contactsBodyHeader" class="contacts-card">
              <card-body *ngFor="let item of contactData; index as contactIndex">
                <div class="contact-info-container">
                  <img src="/v1/profile/photo?email={{ item.email }}" alt="Profile pic" />
                  <div class="contact-info">
                    <div class="name-number">
                      <dxo-label-value [label]="item.contactType" [values]="[item.name]" />
                      <dxo-button
                        [textButton]="true"
                        [href]="'tel:+1-' + item.phoneNumber"
                        [text]="item.phoneNumber"
                      ></dxo-button>
                    </div>
                  </div>
                </div>
                <div class="email-button-div">
                  <div class="min-width">
                    <dxo-button
                      class="email-button"
                      [primary]="item.primaryButton"
                      [icon]="item.emailIcon"
                      [iconColor]="item.primaryButton ? 'white' : 'gray'"
                      [text]="item.email"
                      (handleClick)="copyEmail(item.email, contactIndex)"
                    >
                    </dxo-button>
                  </div>
                  <div class="copy-text-container">
                    <div *ngIf="item.showCopyEmailText" class="copy-text">
                      {{ EmailCopyText }}
                    </div>
                  </div>
                </div>
                <div class="divider"></div>
              </card-body>
              <div class="contact-us">
                <span>{{ MissingContactText }}</span>
                <a data-e2e="contact-us-link" (click)="goContactUsPage()" (keydown)="goContactUsPage()">{{
                  ContactUs
                }}</a>
              </div>
            </dxo-card-responsive>
          </div>
          <div class="min-width">
            <dxo-card-responsive
              *ngIf="displaySurveyCard && hasInterceptLoaded"
              [bodyHeader]="surveyBodyHeader"
              class="survey-card"
            >
              <dxo-loader
                [size]="'small'"
                [color]="'blue'"
                [text]="'Loading survey...'"
                *ngIf="!hasInterceptLoaded"
              ></dxo-loader>
              <card-body class="survey-card-body">
                <div id="dashboard-survey-card"></div>
              </card-body>
            </dxo-card-responsive>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #isLoading>
    <div class="loader-container">
      <dxo-circular-loader [size]="'medium'" [color]="'blue'"></dxo-circular-loader>
    </div>
  </ng-template>
</div>
